export enum ConversationRole {
  CUSTOMER = "CUSTOMER",
  CONTRACTOR = "CONTRACTOR",
  ADMIN = "ADMIN",
}
